import { Button, Image, Box, Text } from "grommet";
import React from "react";
import styled from "styled-components";
import PropTypes from 'prop-types';

const ButtonWrapper = styled(Box)`
    .btn-primary-main {
        position: relative;
        overflow: hidden;
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        border: 1px solid #fff;
        color: #fff;
        display: inline-block;
        padding: 9px 20px;
        //margin-top: 20px;
        border-radius: 5px;
        transition: all 0.7s ease;
        cursor: pointer;
        z-index: 1;
        white-space: nowrap;
        box-shadow: none;
    }
    .btn-primary-main .color-bg {
        position: absolute;
        width: 0;
        height: 0;
        display: block;
        border-radius: 50%;
        background-color: #E6263D;
        transition: width 0.5s ease-in-out, height 0.5s ease-in-out;
        transform: translate(-50%, -50%);
        z-index: 0;
        opacity: 0;
    }
    .btn-primary-main .txt-btn-animation-effect {
        z-index: 1;
        position: relative;
    }
    .btn-primary-main .txt-btn-animation-effect::after {
        content: " ";
        font-family: "icomoon" !important;
        speak: never;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #fff;
        font-size: 8px;
        opacity: 0;
        transition: all 0.5s;
        padding-bottom: 0;
        padding-top: 2px;
        margin-left: -6px;
    }
    @media screen and (max-width: 767px) {
        .btn-primary-main .txt-btn-animation-effect::after {
        display: none;
        }
    }
    
    .btn-primary-main:hover {
        text-decoration: none;
        border-radius: 30px;
        color: #fff;
    }

    .btn-primary-main-disabled:hover {

    }
    
    @media screen and (min-width: 991px) {
        .btn-primary-main:hover {
        padding-left: 20px;
        padding-right: 20px;
        }
    }
    .btn-primary-main:hover .txt-btn-animation-effect {
        position: relative;
    }
    .btn-primary-main:hover .txt-btn-animation-effect::after {
        opacity: 1;
        margin-left: 3px;
        color: #E6263D;
    }
    .btn-primary-main:hover .color-bg {
        width: 600px;
        height: 500px;
        animation: opacity-delay 0.5s;
    }
    .btn-primary-main span.ripple {
        position: absolute;
        border-radius: 50%;
        transform: scale(0);
        animation: ripple 1250ms linear;
        background-color: #E6263D;
    }
    @keyframes ripple {
        to {
        transform: scale(4);
        opacity: 0;
        }
    }
    .btn-primary-main .color-bg {
        display: none !important;
    }
    
    @keyframes opacity-delay {
        0% {
        opacity: 0;
        }
        25% {
        opacity: 0.7;
        }
        50% {
        opacity: 1;
        }
        75% {
        opacity: 0.4;
        }
        100% {
        opacity: 0;
        }
    }

    @media screen and (max-width: 767px) {
        display: inline;
        margin: 0.8vw;
    }
`

const PrimaryButton = ({
    label,
    url,
    icon,
    disabled,
    isMobile,
    ...rest
}) => {



    return (

        <ButtonWrapper width={{min:"130px"}} height={{min:"65px"}}  disabled={disabled} {...rest}> 
            <Button 
                disabled={disabled}
                style={{width: isMobile?'48%':'100%'}}
                onMouseEnter={(event)=>{
                    //console.log(event)
                    //var relX = event.pageX - 
                    //console.log(event.pageX-876.640625)
                    //document?.getElementById("color-bg")?.setAttribute("style",`top:${event.pageX-876.640625};left:${event.pageY-98}`);

                    if(!disabled) {
                    var button = event.currentTarget;
                    var position_btn = button.getBoundingClientRect();
                    var circle = document.createElement("span");
                    var diameter = Math.max(button.clientWidth, button.clientHeight);
                    var radius = diameter / 2;
                    circle.style.width = circle.style.height = "".concat(diameter, "px");
                    circle.style.left = "".concat(event.clientX - position_btn.left - radius, "px"); //console.log(event.clientY , button.offsetTop , radius);

                    circle.style.top = "".concat(event.clientY - position_btn.top - radius, "px");
                    circle.classList.add("ripple");
                    var ripple = button.getElementsByClassName("ripple")[0];

                    if (ripple) {
                        ripple.remove();
                    }

                    button.appendChild(circle);
                }
                }}
                className={"btn-primary-main"}
                size="small"
                gap="small"
                margin={"auto"}
                href={(!disabled)?url:'#'}
                target="_blank"
                label={ 
                    <Text margin={icon? {left:'-0.3rem'}:{}} className={!disabled?"txt-btn-animation-effect":''} alignSelf="center" weight={"lighter"} size="small">{label}</Text>
                }
                icon={ icon && (
                    <Box style={{float:'right'}}>
                    <span id="color-bg" className="color-bg"></span>
                    <span id="ripple" className="ripple" style={{height: "130px", width: "130px", left: "-44.2812px", top: "-59px"}}></span>
                    <Image style={{zIndex:2}} width="22px" height="22px" src={icon}></Image>
                    </Box>)
                }
                reverse={true}
                {...rest}
            >

            
            </Button>
        </ButtonWrapper>
    );
}
PrimaryButton.prototype = {
    url:PropTypes.string,
    icon:PropTypes.string,
    label:PropTypes.string,
    disabled:PropTypes.bool,
}
export { PrimaryButton };